import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { useToast } from '../hooks/use-toast';

const QuoteRequestForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    pickupCity: '',
    destinationCountry: '',
    weight: ''
  });
  const { toast } = useToast();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    toast({
      title: "Quote Request Received!",
      description: "Our team will contact you within 24 hours with the best shipping rates."
    });
    setFormData({ name: '', phone: '', pickupCity: '', destinationCountry: '', weight: '' });
  };

  return (
    <Card className="shadow-2xl">
      <CardHeader>
        <CardTitle className="text-2xl text-center">Request a Shipping Quote</CardTitle>
        <CardDescription className="text-center">Get the best rates for your international shipment</CardDescription>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Full Name *</label>
            <Input
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Your name"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Phone Number *</label>
            <Input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              placeholder="+1 (123) 456-7890"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Pickup City *</label>
            <Input
              name="pickupCity"
              value={formData.pickupCity}
              onChange={handleChange}
              required
              placeholder="e.g., Toronto, Brampton, Vancouver"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Destination Country *</label>
            <Input
              name="destinationCountry"
              value={formData.destinationCountry}
              onChange={handleChange}
              required
              placeholder="e.g., India, Pakistan, UK"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Approx. Parcel Weight (kg) - Optional</label>
            <Input
              type="number"
              name="weight"
              value={formData.weight}
              onChange={handleChange}
              placeholder="e.g., 10, 50, 100"
            />
          </div>
          <Button
            type="submit"
            className="w-full bg-gradient-to-r from-red-600 to-yellow-500 hover:from-red-700 hover:to-yellow-600 text-white h-12 text-lg"
          >
            Get Free Quote Now
          </Button>
        </form>
      </CardContent>
    </Card>
  );
};

export default QuoteRequestForm;